// @flow
import type { FluxStandardAction } from 'flux-standard-action';
import { API_CALL } from './apiMiddleware';
import type { ExtractReturn } from '../types';

export const PARTNER_FETCH = 'gdpr/auth/PARTNER_FETCH';

const fetchPartners: FluxStandardAction<> = (userId) => ({
  type: PARTNER_FETCH,
  payload: [userId],
  meta: {
    [API_CALL]: 'getPartners'
  }
});

export type Actions = ExtractReturn<typeof fetchPartners>;

export type State = {
  +isFetching?: boolean,
  +error?: boolean,
  +result?: {},
  +partners?: []
};

export default function reducer(
  state: State = {},
  action: Actions | FluxStandardAction<>
): State {
  switch (action.type) {
    case PARTNER_FETCH:
      return action.error
        ? {
            ...state,
            isFetching: false,
            error: action.error
          }
        : { partners: action.payload.payload };
    case `${PARTNER_FETCH}_PENDING`:
      return {
        ...state,
        isFetching: true,
        error: false
      };
    default:
      return state;
  }
}

const selectPartners = (state: State): [] => state.partners || [];

export const actions = {
  fetchPartners
};
export const selectors = {
  selectPartners
};
